interface TwitchProps {
  width?: string;
  height?: string;
  fill?: string;
  className?: string;
}

export const Twitch = ({
  width = '31',
  height = '30',
  fill = 'none',
  className,
}: TwitchProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_19956)">
        <path
          className={className}
          d="M4.60352 1.46118H27.9813V17.5334L20.6757 24.839H4.60352V1.46118Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.50803 0L1.68164 5.47917V25.5694H8.9872V29.2222H12.64L16.2928 25.5694H21.7719L29.0775 17.789V0H3.50803ZM27.2511 16.4375L22.1372 21.9167H15.6608L11.7268 24.7786V21.9167H5.33442V1.82639H27.2511V16.4375ZM16.2928 7.30556H14.4664V14.6111H16.2928V7.30556ZM19.9455 7.30556H21.7719V14.6111H19.9455V7.30556Z"
          fill="#8E45F7"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_19956">
          <rect
            className={className}
            width="29.2222"
            height="29.2222"
            fill="white"
            transform="translate(0.220703)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
